import { AppBar, Toolbar, Typography, Box } from '@mui/material'
import React from 'react'
import UserMenu from '../../Features/Auth/components/UserMenu'

const TopBar = () => {
    return (
        <AppBar
            position="fixed"
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
            <Toolbar>
                <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
                    TravelCRM – Panel admina
                </Typography>
                <Box sx={{ ml: 'auto' }}>
                    <UserMenu />
                </Box>
            </Toolbar>
        </AppBar>
    )
}

export default TopBar